import styled from 'styled-components';

export const RatingContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  height: 19px;

  .m-ratings {
    display: flex;
    align-items: center;
    gap: 4px;
  }

  .m-ratings-stars {
    display: flex;
    align-items: center;
    justify-content: center;

    .star-icon-container {
      font-size: 12px;
      line-height: 1;
    }
  }

  .star-number-container {
    font-family: 'Swiss721 BT', sans-serif;
    font-weight: 500;
    font-size: 12px;
    line-height: 1;
    color: #707070;
  }
`;

export const ReviewsCountContainer = styled.span`
  display: inline-flex;
  flex-direction: column;
  align-items: flex-start;
  font-family: 'Swiss721 BT', sans-serif;
  font-weight: 400;
  font-size: 12px;
  line-height: 1.5;
  color: #707070;

  &::after {
    content: '';
    display: block;
    width: 100%;
    height: 1px;
    background-color: #707070;
  }
`;
